<template>
  <div>
    <rt-node
      :title="$tx(title, 'common.annotation')"
      :icon="iconName"
      padding-size="large"
    >
      <template slot="right">
        <rt-button-group>
          <rt-so-button
            @click="uploadFile"
            text-type="upload"
            v-if="canUpload"
          ></rt-so-button>
          <rt-so-button
            @click="deleteFile"
            text-type="delete"
            v-if="canDelete"
            >{{
          }}</rt-so-button>
        </rt-button-group>
      </template>

      <rt-table
        :fetch="getDataList"
        ref="gridTable"
        show-border
        :show-pagination="false"
        header-weight="bold"
        sticky
      >
        <rt-table-column
          :label="$tx('文件名称', 'file.nameLabel')"
          prop="FileName"
        ></rt-table-column>
        <rt-table-column
          :label="$tx('文件大小(字节)', 'tempcredit.fileSize')"
          prop="FileSize"
        ></rt-table-column>
        <rt-table-column :label="$tx('操作', 'common.operate')" align="right">
          <template slot-scope="scope">
            <a
              class="rt-file-list-href"
              :download="scope.row.FileName"
              @click="downloadFile(scope.row)"
              >{{ $tx("下载", "common.downloadBtn") }}</a
            >
            <a
              class="rt-file-list-href"
              v-show="/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(scope.row.FileName)"
              @click="previewFile(scope.row)"
              >{{ $tx("预览", "common.preview") }}</a
            >
          </template>
        </rt-table-column>
      </rt-table>
    </rt-node>

    <rt-dialog
      width="640px"
      :title="$tx('上传附件', 'common.uploadAttachments')"
      v-model="dialogVisible"
      @close="handleClose"
      append-to-body
      :show-footer="false"
    >
      <rt-upload
        ref="upload"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :on-change="fileChanged"
        class="upload-demo"
        drag
        :action="fileUploadUrl"
        :headers="config"
        :data="fileData"
        :name="fileName"
        :file-list="fileList"
        :before-upload="beforeAvatarUpload"
        multiple
        :auto-upload="true"
      >
        <div>
          <img
            v-if="isShowPic"
            src="../../../src/assets/imgs/up-load.png"
            alt
            style="margin-top: 30px"
          />
          <div class="rt-upload__text" :class="{ upload: !isShowPic }">
            {{ $tx("将文件拖到此处，或", "common.drogFile") }}
            <em>{{ $tx("点击上传", "common.clickUpload") }}</em>
          </div>
        </div>
      </rt-upload>
    </rt-dialog>
    <rt-dialog
      :title="$tx('预览', 'common.preview')"
      v-model="previewDialog"
      @close="previewClose"
      append-to-body
      :show-footer="false"
    >
      <img :src="previewImgUrl" style="width: 100%; min-height: 500px" />
    </rt-dialog>
  </div>
</template>
<script>
export default {
  name: "RtFileList",
  props: {
    title: {
      type: String,
      default: "注释",
    },
    iconName: {
      type: String,
      default: "注释",
    },
    moduleType: {
      type: String,
      required: true,
    },
    objectId: {
      type: String,
      required: true,
    },
    canUpload: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    canDownload: {
      type: Boolean,
      default: true,
    },
    canPreview: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dataList: [],
      loading: false,
      dialogVisible: false,
      fileUploadUrl: "../api/attachment/upload",
      fileName: "",
      config: {
        Authorization: "Bearer " + this.$store.state.auth.accessToken,
      },
      fileData: {
        ModuleType: this.moduleType,
        FileId: "",
        FileName: this.fileName,
        ObjectId: this.objectId,
        IsOverwrite: "0",
      },
      fileList: [],
      previewImgUrl: "",
      previewDialog: false,
      readFileList: [],
      isShowPic: true,
    };
  },
  watch: {
    objectId(newVal) {
      if (newVal) {
        this.fileData.ObjectId = newVal;
        this.reloadData();
      }
    },
  },
  mounted() {
    
  },
  methods: {
    reloadData() {
      this.$refs.gridTable.loadData();
    },
    getDataList() {
      let apiUrl = `api/attachment?moduleType=${this.moduleType}&objectId=${this.objectId}`;
      return rt
        .get(apiUrl)
        .then((res) => {
          this.dataList = res;
          return this.dataList;
        })
        .catch((error) => {
          rt.showErrorToast(error);
        });
    },
    // 限制文件大小
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$message.error(
          this.$tx(
            "上传文件大小不能超过 5MB!",
            "tempcredit.uploadFilenotExceed5MB"
          )
        );
      }
      return isLt2M;
    },

    //下载附件
    downloadFile(row) {
      window.open(
        rt.getBaseUrl() +
          "api/attachment/download/" +
          this.moduleType +
          "/" +
          row.Id
      );
    },
    previewFile(row) {
      let { FileName, Id } = row;

      let isImage = /\.(png|jpe?g|gif|svg)(\?.*)?$/.test(FileName);
      if (!isImage) return;
      this.previewImgUrl =
        rt.getBaseUrl() +
        "api/attachment/download/" +
        this.moduleType +
        "/" +
        Id;
      this.previewDialog = true;
    },
    previewClose() {
      this.previewImgUrl = "";
      this.previewDialog = false;
    },
    deleteFile() {
      if (!this.canDelete) return;
      let selectedList = this.$refs.gridTable.selection;
      if (selectedList.length === 0) {
        rt.showErrorToast(
          this.$tx("请至少选择一个文件", "file.selectLeastFile")
        );
        return;
      }
      var that = this;
      that
        .$confirm(
          this.$tx("是否要删除？", "common.isDelete"),
          this.$tx("警告", "common.warning"),
          {
            confirmButtonText: this.$tx("确认", "common.confirm"),
            cancelButtonText: this.$tx("取消", "common.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          let baseUrl = "api/attachment/delete/" + this.moduleType + "/";
          let promiseList = selectedList.map((item) => {
            return rt.get(baseUrl + item.Id);
          });
          Promise.all(promiseList)
            .then(() => {
              this.reloadData();
            })
            .catch((error) => {
              rt.showErrorToast(error);
            });
        });
    },
    uploadFile() {
      this.dialogVisible = true;
    },
    fileChanged(file, fileList) {
      var errorMessage = "";
      if (!rt.isNullOrWhiteSpace(errorMessage)) {
        this.$message({
          showClose: true,
          message: errorMessage,
          type: "warning",
        });
        fileList.splice(fileList.length - 1, 1);
        return;
      }
      this.attachmentList = fileList;
      this.fileName = file.name;
      this.fileData.FileName = file.name;
      // this.fileList = [];
      // this.fileList.push({
      //   name: file.name,
      //   url: ""
      // });
    },
    uploadSuccess(response, file, fileList) {
      let success = true;
      this.readFileList = fileList;
      this.isShowPic = false;
      fileList.forEach((item) => {
        if (item.status !== "success") {
          success = false;
        }
      });
      if (success) {
        this.$message({
          showClose: true,
          message: this.$tx("附件上传成功！", "file.attachmentUpload"),
          type: "success",
        });
        this.reloadData();
      }

      // 上传成功
      // if (response.ErrorCode == 0) {
      //   this.$message({
      //     showClose: true,
      //     message: file.name + "附件上传成功！",
      //     type: "success"
      //   });
      // } else {
      //   this.$message({
      //     showClose: true,
      //     message: response.Message,
      //     type: "error"
      //   });
      // }
    },
    uploadError(err, file) {
      // 上传失败
      this.$message({
        showClose: true,
        message: err,
        type: "error",
      });
    },
    handleClose() {
      this.$refs.upload.clearFiles();
      this.isShowPic = true;
    },
  },
};
</script>
<style scoped lang="less">
.rt-upload {
  width: 100%;
}
.upload-demo {
  position: relative;
  text-align: center;
  margin-top: 50px;
}
.upload-demo .rt-upload-list__item-name {
  height: 26px;
  color: #143e81 !important;
}
.upload-demo .rt-upload-list__item-name [class^="rt-icon"] {
  height: initial;
}
a.rt-file-list-href {
  cursor: pointer;
  color: #1890ff;
  text-decoration: none;
  font-size: 15px !important;
}
.upload {
  text-align: left !important;
  margin-left: 22px;
}
.rt-upload-list {
  position: absolute;
  top: 38%;
  left: 9%;
  right: 9%;
}
.rt-upload-list__item {
  background: #f7f9fc;
  padding: 0 22px;
  color: #143e81 !important;
}
.rt-upload-list__item-status-label i {
  margin-top: 6px;
}
.rt-upload-list__item .rt-icon-upload-success {
  color: #55ceb3;
}
</style>



// WEBPACK FOOTER //
// file-list.vue?67831615